/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/broker_submissions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/broker_submissions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/broker_submissions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-broker_submissions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/broker_submissions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/broker_submissions-entity-config.ts
 * Public fields: 10/10 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const BrokerSubmissionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  submitted_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // submitted_by_user_profile_id field
  submission_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // submission_status_id field
  note: Type.Union([Type.String(), Type.Null()]), // note field
  submitted_at: Type.String({ format: "date-time" }), // submitted_at field
  reviewed_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // reviewed_by_user_profile_id field
  reviewed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // reviewed_at field
  review_notes: Type.Union([Type.String(), Type.Null()]), // review_notes field
  created_at: Type.String({ format: "date-time" }), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateBrokerSubmissionsSchema = Type.Object({
  submitted_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // submitted_by_user_profile_id field
  submission_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // submission_status_id field
  note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // note field
  submitted_at: Type.Optional(Type.String({ format: "date-time" })), // submitted_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  review_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // review_notes field
});

export const UpdateBrokerSubmissionsSchema = Type.Object({
  submitted_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // submitted_by_user_profile_id field
  submission_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // submission_status_id field
  note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // note field
  submitted_at: Type.Optional(Type.String({ format: "date-time" })), // submitted_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  review_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // review_notes field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type BrokerSubmissionsRow = Static<typeof BrokerSubmissionsSchema>;
export type BrokerSubmissionsInsert = Static<typeof CreateBrokerSubmissionsSchema>;
export type BrokerSubmissionsUpdate = Static<typeof UpdateBrokerSubmissionsSchema>;

// Legacy type aliases for backward compatibility
export type BrokerSubmissions = BrokerSubmissionsRow;
export type CreateBrokerSubmissions = BrokerSubmissionsInsert;
export type UpdateBrokerSubmissions = Static<typeof UpdateBrokerSubmissionsSchema>;

// Field configuration metadata
export const BrokerSubmissionsFieldConfig = {
  filterable: ['id', 'submitted_by_user_profile_id', 'submission_status_id', 'reviewed_by_user_profile_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'submitted_at', 'created_at', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface BrokerSubmissionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface BrokerSubmissionsResponse {
  data: BrokerSubmissions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleBrokerSubmissionsResponse {
  data: BrokerSubmissions | null;
  error: Error | null;
}
